<template>
  <SelectComponent
    v-if="items.length"
    class="post-publishing"
    :value="relationRef"
    @input="setRelation"
    :items="items"
    :label="$t('publishPostSelectPost')"
  />
</template>

<script>
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'
import fetch from '@/fetch'

const getSchema = (source = '') => {
  const parts = (source || '').split('.')
  return parts[1] || parts[0]
}

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    reference: {
      type: Object,
      default: () => ({}),
    },
    id: String,
    source: String,

    // schemas this post can be published under, declared by the themesettings
    references: {
      type: Array,
      default: null,
    },
    isSlot: Boolean,
    disabled: Boolean,
    isValid: {
      type: Boolean,
      default: true,
    },
    validationMessage: String,
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      candidates: [],
      hasSuggested: false,
    }
  },
  watch: {
    'reference.ref': {
      handler: 'fetchCandidates',
      immediate: true,
    },
    items: 'applySuggestedRelation',
  },
  computed: {
    relationRef() {
      return this.$path(['ref'], this.value)
    },
    schema() {
      return getSchema(this.source)
    },
    items() {
      return this.candidates.filter(
        item => this.isAllowedSchema(item) && !this.isSameSchema(item) && !this.isSelfOrDescendant(item),
      )
    },
  },
  methods: {
    setRelation(ref) {
      this.$emit('input', {
        ref: ref || null,
        onModel: ref ? 'Post' : null,
      })
    },
    fetchCandidates() {
      if (!this.reference.ref) return (this.candidates = [])

      const params = new URLSearchParams({
        'field.id': 'id',
        'field.label': 'title',
        'field.thumbnail': 'media.cover.0.url',
        'field.parent': 'publishing.relation.ref',
        'field.source': 'customFieldsConfig.0.source',
        references: this.reference.ref,
      })

      return fetch(`/api/resource/post?${params.toString()}`)
        .then(res => res.json())
        .then(candidates => (this.candidates = candidates))
    },

    // posts of the same schema belong in the same place - follow what the siblings already do
    applySuggestedRelation() {
      if (this.hasSuggested || this.relationRef) return

      const sibling = this.candidates.find(item => item.id !== this.id && item.parent && this.isSameSchema(item))

      console.log(sibling)
      if (!sibling) return

      // only suggest a parent the user could have picked themselves
      if (!this.items.some(item => item.id === sibling.parent)) return

      this.hasSuggested = true
      this.setRelation(sibling.parent)
    },

    // the theme decides which schemas a post can be published under
    isAllowedSchema(item) {
      if (!this.references) return true
      return this.references.includes(getSchema(item.source))
    },

    // a post of the same schema is a sibling, not a parent
    isSameSchema(item) {
      if (!this.schema) return false
      return getSchema(item.source) === this.schema
    },

    // a post cannot be published under itself, or under one of its own children
    isSelfOrDescendant(item) {
      if (!this.id) return false

      const seen = new Set()
      let current = item

      while (current && !seen.has(current.id)) {
        if (current.id === this.id) return true
        seen.add(current.id)
        current = this.candidates.find(i => i.id === current.parent)
      }

      return false
    },
  },
  components: {
    SelectComponent,
  },
}
</script>

<style lang="scss">
.post-publishing {
  .field-select-modal__item-thumbnail {
    object-fit: contain;
  }
}
</style>
